import { api } from '.'

export async function generateDepositAddressFn(values: any): Promise<any> {
  const { data } = await api.post<any>(`/user/save/deposit/address`, {
    ...values,
  })

  return data
}

export async function withdrawFn(values: any): Promise<any> {
  const { data } = await api.post<any>(`/user/save/withdraw`, {
    ...values,
  })

  return data
}
